import styled from "styled-components"

const SearchButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const NotificationButton = styled.button`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const BackgroundText = styled.div`
  color: ${(props) => props.theme.a_color_gradients.a_medium};
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

const Container = styled.div`
  background-color: ${(props) => props.theme.b_color_gradients.b_dark};
`

export { SearchButton, NotificationButton, BackgroundText, Container }
